export enum ESideBar {
    Logout = -1
}

